<h2 mat-dialog-title>{{ titleKey | translate }}</h2>

<mat-dialog-content>
	<p class="create-worker-target">
		<span class="create-worker-label">{{ 'administration.sync-monitoring.create-worker-dialog.environment' | translate }}:</span>
		<strong>{{ environmentName }}</strong>
	</p>

	<form [formGroup]="workerForm">
		<mat-form-field appearance="outline" class="create-worker-name">
			<mat-label>
				{{ 'administration.sync-monitoring.create-worker-dialog.name' | translate }}
			</mat-label>
			<input matInput formControlName="name" [attr.aria-label]="'administration.sync-monitoring.create-worker-dialog.name' | translate" />
			@if (!isNameValid) {
				<mat-error>
					{{ 'administration.sync-monitoring.create-worker-dialog.name-required' | translate }}
				</mat-error>
			}
		</mat-form-field>

		<div class="create-worker-filters" formArrayName="filters">
			<div class="create-worker-filters-header">
				<span class="create-worker-filters-title">
					{{ 'administration.sync-monitoring.create-worker-dialog.filters' | translate }}
				</span>
				<button mat-stroked-button type="button" (click)="addFilter()">
					{{ 'administration.sync-monitoring.create-worker-dialog.add-filter' | translate }}
					<mat-icon svgIcon="acies_add"></mat-icon>
				</button>
			</div>

			<p class="create-worker-filters-hint">
				{{ 'administration.sync-monitoring.create-worker-dialog.filters-hint' | translate }}
			</p>

			@if (filters.length === 0) {
				<p class="create-worker-filters-empty">
					{{ 'administration.sync-monitoring.create-worker-dialog.no-filters' | translate }}
				</p>
			}

			@for (filter of filters.controls; track filter; let i = $index) {
				<div class="create-worker-filter-row" [formGroupName]="i">
					<mat-form-field appearance="outline" class="create-worker-filter-field">
						<mat-label>
							{{ 'administration.sync-monitoring.create-worker-dialog.filter-name' | translate }}
						</mat-label>
						<input matInput formControlName="name" />
					</mat-form-field>
					<mat-form-field appearance="outline" class="create-worker-filter-field">
						<mat-label>
							{{ 'administration.sync-monitoring.create-worker-dialog.filter-value' | translate }}
						</mat-label>
						<input matInput formControlName="value" [matAutocomplete]="valueAuto" />
						<mat-autocomplete #valueAuto="matAutocomplete">
							@for (jobType of jobTypeValues; track jobType) {
								<mat-option [value]="jobType">{{ jobType }}</mat-option>
							}
						</mat-autocomplete>
					</mat-form-field>
					<button mat-icon-button type="button" class="create-worker-filter-remove" (click)="removeFilter(i)" [attr.aria-label]="'administration.sync-monitoring.create-worker-dialog.remove-filter' | translate">
						<mat-icon svgIcon="acies_delete"></mat-icon>
					</button>
				</div>
			}

			@if (hasDuplicateFilterNames) {
				<p class="create-worker-error">
					{{ 'administration.sync-monitoring.create-worker-dialog.duplicate-filter-names' | translate }}
				</p>
			}
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions align="end">
	<button mat-button type="button" [disabled]="isLoading" (click)="onCancel()">
		{{ 'general.cancel' | translate }}
	</button>
	<button mat-flat-button color="primary" type="button" [disabled]="!canConfirm" (click)="onConfirm()">
		@if (isLoading) {
			<mat-progress-spinner diameter="18" mode="indeterminate" class="create-worker-spinner"></mat-progress-spinner>
		}
		{{ confirmKey | translate }}
	</button>
</mat-dialog-actions>
